import { Ptag } from "components/core";
import React, { useMemo } from "react";
import AttributeInnerCard from "./AttributeInnerCard";
import { AttributeDefaultHeaderWrapper } from "./styles";
import AttributeCoPayment from "./AttributeCoPayment";

function RenderDefault({ data }) {
  const isCoPayment = useMemo(() => {
    return ["esc", "parents"].some((key) => key in data);
  }, [data]);

  if (isCoPayment) return <AttributeCoPayment data={data} />;

  if (!data?.limit && !data?.remarks) return null;
  
  return (
    <>
      <AttributeDefaultHeaderWrapper>
        <AttributeInnerCard
          title={data?.min || data?.max ? "Default" : "Limit"}
          value={data?.limit}
          width="200px"
        />
        {data?.min && (
          <AttributeInnerCard
            title="Minimum Limit"
            value={data?.min}
            width="200px"
          />
        )}
        {data?.max && (
          <AttributeInnerCard
            title="Maximum Limit"
            value={data?.max}
            width="200px"
          />
        )}
      </AttributeDefaultHeaderWrapper>
      <article>
        {data?.remarks && (
          <Ptag fontWeight="400" color="#4a4a4a" marginTop="18px">
            Remarks: {data?.remarks}
          </Ptag>
        )}
      </article>
    </>
  );
}

export default RenderDefault;
